import React from "react";
import styles from "./imageSelector.module.css";

export default function ImageSelector({ onChange, selectedPhotoSrc }) {
  return (
    <div className={styles.imageSelector}>
      <input type="file" onChange={onChange} className={styles.fileInput} />
      {selectedPhotoSrc && (
        <img
          className={styles.selectedImg}
          src={selectedPhotoSrc}
          alt="selected"
        />
      )}
    </div>
  );
}
